export type StockAvailability = 'In Stock' | 'Out of Stock';

type ValidateStockStatusParams = {
    availableStock?: number;
    minimumCaseQty?: number;
    isCustomPharmacyOOS?: string | boolean | null;
    isDoordashAvailable?: boolean;
};

export function validateStockStatus(params: ValidateStockStatusParams): StockAvailability {
    const { availableStock, minimumCaseQty, isCustomPharmacyOOS, isDoordashAvailable } = params;

    if (isDoordashAvailable === false) return 'Out of Stock';

    const stockQuantity = availableStock ?? 0;
    const minimumQuantity = minimumCaseQty ?? 0;
    const customPharmacyIsOutOfStock =
        typeof isCustomPharmacyOOS === 'string'
            ? isCustomPharmacyOOS.toLowerCase() === 'true'
            : Boolean(isCustomPharmacyOOS);

    const isOutOfStock = customPharmacyIsOutOfStock || stockQuantity <= 0 || minimumQuantity > stockQuantity;

    if (isOutOfStock) {
        return 'Out of Stock';
    }

    return 'In Stock';
}
